<template>
  <QuickActionButton
    icon="icon-repeat"
    title="Replace Gateway"
    :subtitle="`Quickly replace ${gatewayIdStr} with another Gateway`"
    @click="replaceGatewayModal?.$el?.present()"
  ></QuickActionButton>
  <IonModal ref="replaceGatewayModal">
    <IonHeader class="ion-no-border px-[10px] bg-white">
      <IonToolbar color="white" class="border-b-2 border-gray-300">
        <IonTitle color="medium"><i class="icon-repeater mr-2"></i>Replace {{ gatewayIdStr }}</IonTitle>
        <IonButtons slot="end">
          <IconButton icon="icon-x" @click="replaceGatewayModal?.$el?.dismiss()"></IconButton>
        </IonButtons>
      </IonToolbar>
    </IonHeader>
    <IonContent>
      <ReplaceDeviceForm :device-to-replace="gatewayId" @on-replace-result="onReplaceResult"></ReplaceDeviceForm>
    </IonContent>
  </IonModal>
</template>

<script setup lang="ts">
import IconButton from '@/components/forms/IconButton.vue';
import QuickActionButton from '@/components/forms/QuickActionButton.vue';
import { useToast } from '@/composables/use-toast';
import { ReplaceDeviceResult } from '@/http-services/device.service';
import { useSelectedProperty } from '@/stores/selected-property.store';
import ReplaceDeviceForm from '@/views/tools/replace-device/ReplaceDeviceForm.vue';
import {
  createAnimation,
  IonButtons,
  IonContent,
  IonHeader,
  IonModal,
  IonTitle,
  IonToolbar,
  useIonRouter,
} from '@ionic/vue';
import { ConversionUtils } from '@ncss/models';
import { computed, useTemplateRef } from 'vue';

const props = defineProps<{
  gatewayId: number;
}>();
const selectedProperty = useSelectedProperty();
const gatewayIdStr = computed(() => ConversionUtils.ConvertSerialNumberToString(props.gatewayId));
const replaceGatewayModal = useTemplateRef('replaceGatewayModal');
const { successToast, errorToast } = useToast();
const router = useIonRouter();

function present() {
  return replaceGatewayModal.value?.$el?.present();
}

async function onReplaceResult(res: ReplaceDeviceResult) {
  if (res.success) {
    const gatewayId = res.device.deviceId;
    const propertyId = selectedProperty.property?._id;
    const snStr = ConversionUtils.ConvertSerialNumberToString(gatewayId);
    successToast(`${snStr} programmed!`);
    await replaceGatewayModal.value?.$el?.dismiss();
    await selectedProperty.refresh();
    setTimeout(() => {
      if (propertyId) {
        router.replace(`/gateway/${propertyId}`, () => createAnimation());
      }
    }, 100);
  } else {
    const msg = res.errors[0].msg;
    errorToast(msg || 'Failed to replace Gateway');
  }
}

defineExpose({ present });
</script>

<style scoped></style>
